/**
 * P3-21: MetaphysicsPerkButton —— Metaphysics perk 按钮（迁移自
 * classes.ui.PrestigeBtnController + BuildingResearchBtn，
 * js/prestige.js:574-601 / core.js:2402-2404）。
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import { usePrestigeButtonModel } from "./useScienceModel";

interface MetaphysicsPerkButtonProps {
  perkName: string;
}

export function MetaphysicsPerkButton({ perkName }: MetaphysicsPerkButtonProps) {
  const { snap, modelRef, controller, getTooltip } =
    usePrestigeButtonModel(perkName);

  const onClick = useCallback(
    (event: MouseEvent) => {
      const model = modelRef.current;
      if (controller && model) {
        controller.buyItem?.(model, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      getTooltip={getTooltip}
      onClick={onClick}
      getSelectedObject={() => modelRef.current}
    />
  );
}
